'use client';

import PRODUCTPAGE from '@/views/product/scheduling';

export default PRODUCTPAGE;
